module.exports = __webpack_public_path__ + "static/img/mobile-web-01-img@t.a0a6817.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/mobile-web-01-img@t.png
// module id = p24C
// module chunks = 0